import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';
import ca from './locales/ca.json';

const LANGUAGE_EN = 'en';
const LANGUAGE_ES = 'es';
const LANGUAGE_CA = 'ca';

const STORAGE_LANGUAGE = 'language';
const DEFAULT_LANGUAGE = LANGUAGE_EN;

const currentLanguage = localStorage.getItem(STORAGE_LANGUAGE) || DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
    lng: currentLanguage,
    fallbackLng: [LANGUAGE_EN, LANGUAGE_ES, LANGUAGE_CA],
    interpolation: {
        escapeValue: false,
    },
    resources: {
        en: {
            translation: en,
        },
        es: {
            translation: es,
        },
        ca: {
            translation: ca,
        },
    },
});

export const setLanguage = (code: string) => {
    i18n.changeLanguage(code);
    localStorage.setItem(STORAGE_LANGUAGE, code);
};

export default i18n;
